import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface LogoProps {
    isNewImage?: boolean
}

export default function Logo(props: LogoProps): JSX.Element{

    const nav = useNavigate();
    const { i18n } = useTranslation();

    const onClick = () => {
        nav("/")
    }
    return (
        <>
            {!props.isNewImage && i18n.language === "en" && <img className="new-amp" src="./images/mpac-amp-logo-en.png" onClick={() => onClick()} alt=""></img>}
            {!props.isNewImage && i18n.language === "fr" && <img className="new-amp" src="./images/mpac-amp-logo-fr.png" onClick={() => onClick()} alt=""></img>}
            {props.isNewImage && i18n.language === "en" && <img className="new" src="./images/mpac-logo-en.svg" onClick={() => onClick()} alt=""></img>}
            {props.isNewImage && i18n.language === "fr" && <img className="new" src="./images/mpac-logo-fr.svg" onClick={() => onClick()} alt=""></img>}
        </>
    )
}